import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GET_STATISTICS_3K_CHAIN_API_URL, GET_STATISTICS_ACCOUNT_EXCEL_API_URL, GET_STATISTICS_ACTIVE_KTV_API_URL, GET_STATISTICS_ACTUALIZATION_HOUSE_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_EXCEL_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_RAPORT_EXCEL_API_URL, GET_STATISTICS_CABLE_ACCOUNT_API_URL, GET_STATISTICS_CABLE_CANTON_API_URL, GET_STATISTICS_CABLE_EXCEL_API_URL, GET_STATISTICS_INFRASTRUCTURE_ACCOUNT_API_URL, NETSTAT_SWITCH_TOPO_URL } from '../OpticApiConfig';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { loadingCanton } from '../LoadingData/LoadingDataTerritory';


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 

const Statistic3kChain = () => {
   const [selectedCanton, setSelectedCanton] = useState('');
  const [resultCantonOptic, setCantonOptic] = useState([]);
  const [filteredResult, setFilteredResult] = useState([]);
  const [error, setError] = useState(null);  
  const token = localStorage.getItem('token');
  const [canton, setCanton] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [regionFilter, setRegionFilter] = useState('');

  useEffect(() => {
    loadingCanton(setCanton); 
  }, []); 

  // Загрузка данных
const handleButtonClick = async () => {
  if (!selectedCanton) {
    setError('Пожалуйста, выберите округ.');
    return;
  }

  try {
    setError(null); 
    const response = await axios.get(GET_STATISTICS_3K_CHAIN_API_URL, {
      headers: { Authorization: `Bearer ${token}` },
      params: { canton: selectedCanton }
    });

    setCantonOptic(response.data); // ✅ правильное имя
    setFilteredResult(response.data);
    setIsVisible(true);
  } catch (error) {
    console.error(error);
    setError('Произошла ошибка при загрузке данных.');
  }
};

  // Фильтр по area
  const handleRegionFilterChange = (e) => {
    const value = e.target.value;
    setRegionFilter(value);

    if (!value) {
      setFilteredResult(resultCantonOptic);
      return;
    }

    const filtered = resultCantonOptic.filter(item => 
      item.region.toString().includes(value)
    );
    setFilteredResult(filtered);
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>  
        <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <label className='textTitleDrawer' style={{ fontSize: "20px", marginLeft: "10px", textShadow: '2px 2px 4px rgba(7, 7, 7, 1)' }}>
           Паровозы 3К
          </label>
          <Select
            className="selectSearchDrawer"
            options={canton.map(option => ({ value: option, label: option }))}
            isSearchable={true}
            styles={customStyles}
            placeholder="Округ"
            onChange={(selectedOption) => setSelectedCanton(selectedOption.value)} 
          />
          <button 
            className='buttonAutoTopology' 
            style={{ marginTop: "0px", padding: "10px" }}
            onClick={handleButtonClick} 
          >
            Загрузить
          </button>
        </div>
        <hr className="horizontalLineDrawer" style={{ marginTop: "0px" }} />
      </div>
   
      {isVisible && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          
          {/* Фильтр по area */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
            <label style={{ marginLeft: '10px',color: "#c5c5c5", textShadow: '2px 2px 4px #131212ff'}}>Всего: <span style={{color: "orange"}}>{filteredResult.length}.</span></label>
           
            <input 
              type="number" 
              value={regionFilter} 
              onChange={handleRegionFilterChange} 
              placeholder="поиск по регионам" 
              className='textInputPoiskModal'
              style={{width: '150px',fontSize: '14px'}}
            />
           
          </div>

         <div className="scroll-container" 
            style={{
              flex: 1,
              maxWidth: "100%",
              maxHeight: "70vh",  // ✅ вместо height
              overflowY: "auto",
              paddingBottom: "10px",
              display: "block" ,
              marginTop: '-20px'   // ✅ чтобы scroll работал
            }}>
          <table className="results-table" style={{ fontSize: '14px', tableLayout: 'fixed' }}>
              <thead>
                <tr>
                  <th>Округ</th>
                  <th>Регион</th>
                  <th>Ветка</th>
                  <th>Улица</th>
                  <th>Дом</th>
                  <th>Модель</th>
                  <th>Ip</th>
                  <th>Mac</th>
                  <th>Тип</th>
                </tr>
              </thead>
              <tbody>
                {filteredResult.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="no-data">Нет данных для отображения</td>
                  </tr>
                ) : (
                  filteredResult.map((item, index) => (
                    <tr key={index} >
                      <td className="text-shadow-statistics" style={{textShadow: '2px 2px 4px #212121ff'}}>{item.canton}</td>
                      <td className="text-shadow-statistics">{item.region}</td>
                      <td className="text-shadow-statistics">{item.area}</td>
                      <td className="text-shadow-statistics">
                        {item.street.split('(').map((part, index) => (
                          <span key={index}>
                            {index === 0 ? part.trim() : `(${part.trim()}`}
                            <br/>
                          </span>
                        ))}
                      </td>
                      <td className="text-shadow-statistics">{item.house}</td>
                      <td className="text-shadow-statistics">{item.model}</td>
                      <td className="text-shadow-statistics">
                        <a
                          href={`${NETSTAT_SWITCH_TOPO_URL}ip=${item.ip}&action=up`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#92fd88b3" }}
                        >
                          {item.ip}
                        </a>
                      </td>

                      <td className="text-shadow-statistics">{item.mac}</td>
                      <td
                        className="text-shadow-statistics"
                        style={{ color: item.type === "PON" ? "#8fa0ffff" : "#ee8a83ff" }}
                      >
                        {item.type}
                      </td>
                    
                     
                      
                    
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default Statistic3kChain;